import { render, staticRenderFns } from "./AgendaLettingPropertyDetails.vue?vue&type=template&id=fba9d4de&"
import script from "./AgendaLettingPropertyDetails.vue?vue&type=script&lang=js&"
export * from "./AgendaLettingPropertyDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports